// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableSection__container--2Nl","icon":"ExpandableSection__icon--Zjd","title":"ExpandableSection__title--Wlp","btn":"ExpandableSection__btn--3_N"};